import { useMutation, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';
import { IUser, QueryKey } from 'common-types';
import { api } from 'services/api';
import { useLocalStorageStore } from 'store';
import { useShallow } from 'zustand/shallow';

export const useSetUserData = (
  options?: UseMutationOptions<unknown, unknown, IUser>,
): UseMutationResult<unknown, unknown, IUser, unknown> => {
  const { userId } = useLocalStorageStore(useShallow((state) => ({ userId: state.userId })));

  return useMutation({
    mutationKey: [QueryKey.USER_DATA, userId],
    mutationFn: (userData: IUser) => api.setUserInfo({ userData }, userId),
    ...options,
  });
};
